module.exports = __webpack_public_path__ + "GQ.png?08498f98e623b977752c9ebdeb96f437";